/* eslint no-unused-vars: ["error", { "args": "none" }] */
import api from '@/api';
import i18n from '@/i18n';
import utilities from '@/helpers/utilities';

const state = {
    demandType: {},
    demandTypes: [],
};

const mutations = {
    setDemandType(state, demandType) {
        state.demandType = demandType;
    },
    setDemandTypes(state, demandTypes) {
        state.demandTypes = demandTypes;
    },
};

const actions = {
    async loadDemandTypes({ commit }) {
        const response = await api.demandTypes.list();
        commit('setDemandTypes', response.data);
    },

    async fetchDemandType({ commit }, id) {
        const response = await api.demandTypes.get(id);
        commit('setDemandType', response.data);
    },
    async removeDemandType({ dispatch }, form) {
        await api.demandTypes.remove(form.id);
        await dispatch('loadDemandTypes');
        if (form.isInUse) {
            dispatch('showSuccess', i18n.t('message.success.demandTypeRemoved'));
        } else {
            dispatch('showSuccess', i18n.t('message.success.demandTypeDisabled'));
        }
    },
    async saveDemandType({ commit, dispatch, state }, form) {
        const response = await api.demandTypes.save(form);
        await dispatch('fetchDemandType', response.data.id);
    },
    async saveOrUpdateDemandType({ dispatch }, form) {
        if (utilities.isEmptyOrZero(form.id)) {
            await dispatch('saveDemandType', form);
        } else {
            await dispatch('updateDemandType', form);
        }

        await dispatch('loadDemandTypes');
        dispatch('showSuccess', i18n.t('message.success.saved'));
    },
    async updateDemandType({ dispatch }, form) {
        await api.demandTypes.update(form.id, form);
    },
};

const getters = {
    demandType(state) {
        return state.demandType;
    },
    demandTypes(state) {
        const demandTypes = state.demandTypes || [];
        return demandTypes.sort((a, b) => utilities.stringCompare(a.name, b.name));
    },
    demandTypesValueText(_, getters) {
        return getters.demandTypes.map(({ id, name, isActive }) => ({
            value: id,
            text: name,
            isActive,
        }));
    },
    demandTypesDictionary(_, getters) {
        return getters.demandTypes.reduce((map, obj) => {
            map[obj.id] = obj;
            return map;
        }, {});
    },
};

export default {
    state,
    mutations,
    actions,
    getters,
};




// WEBPACK FOOTER //
// ./src/store/modules/demandTypes.js